// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-belmont -> aion-management-belmont -> holly-court
// Generated: 2026-10-23T20:39:48.498Z
// Counts: 1 design, 68 content, 65 slot group, 1 collection binding, 9 section, 9 style

export const designOverrides = {
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.pretitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Studio - 2 BEDROOM LAYOUTS</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Studio - 2 Bedroom Apartments for Rent in Pitman , NJ</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodshowcase.description": {
    "overrideType": "VALUE",
    "customValue": "<p>At Holly Court in Pitman, NJ, life's vibrant tapestry unfolds just beyond your doorstep. Enjoy proximity to cultural gems like the Broadway Theatre, the Pitman Historical Museum, and the artistry of the Pitman Gallery. With cozy studios to spacious two-bedroom apartments, your perfect home awaits—come and experience local treasures!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>tour anytime. from anywhere.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.title": {
    "overrideType": "VALUE",
    "customValue": "<p>We're Here For You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>your new home awaits</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Embrace Comfort and Connection in Your Ideal Apartment Home</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_fav_icon"
  },
  "accessibility-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Accessibility Statement</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Holly Court in <a href=\"https://www.livehollycourt.com/neighborhood/\">Pitman, NJ</a>, experience a lifestyle enhanced by modern comforts and vibrant community spaces. Our apartments feature stylish designs, spacious floor plans, and desirable amenities, including a refreshing pool, state-of-the-art fitness center, and serene picnic areas. Make every day extraordinary with us—your ideal home awaits!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Amenities</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Features</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentOverline": {
    "overrideType": "VALUE",
    "customValue": "<h3>Interior</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Amenities</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityOverline": {
    "overrideType": "VALUE",
    "customValue": "<h3>Community</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.select_units_disclaimer": {
    "overrideType": "VALUE",
    "customValue": "*In Select Homes",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Apply Now</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Contact Us</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Floor Plans</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Spaciously Designed Apartments For Rent</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Gallery</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/patio-balcony-apartments-fullerton-pa::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Discover ideal apartments with patio or balcony in Fullerton, PA. Enjoy serene outdoor spaces with modern amenities at Fairmont Place.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/patio-balcony-apartments-fullerton-pa::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments with Patios &amp; Balconies in Fullerton, PA</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore the community layout</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Neighborhood</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Pet-friendly living guidelines</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet Restrictions</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dogs &amp; Cats Welcome</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Privacy Policy</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Resident Portal</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccess.app_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Download the Loft Resident Mobile App</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>What residents are saying</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Schedule a Tour</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduletourform.form_block": {
    "overrideType": "VALUE",
    "customValue": "elise-schedule-tour-iframe",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Sitemap</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Virtual Tours</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Holly Court in Pitman, NJ, your ideal home awaits with stylish studio to two-bedroom floor plans. Enjoy a vibrant lifestyle with amenities like a pool, dog park, and fitness center. Upgrade your comfort with modern appliances and spacious walk-in closets. Lease online today and make Holly Court your home!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Holly Court in charming Pitman, NJ, our diverse floor plans—ranging from cozy studios to spacious two-bedroom layouts—cater to every lifestyle. Each residence is designed for comfort and convenience. Have questions? Contact our leasing team today to find the perfect fit for you!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Holly Court in Pitman, NJ, a lifestyle of comfort awaits you! Choose from stylish studio, one-bedroom, or two-bedroom layouts designed to fit your needs. Every floor plan offers a unique space to call home. Browse our available apartment homes today and uncover your ideal sanctuary!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Holly Court in Pitman, NJ, picture yourself enjoying tranquil sunny days by the pool and cozy evenings in stylish, pet-friendly apartments. Choose from versatile <a href=\"https://www.livehollycourt.com/floor-plans/\">studio, one, or two-bedroom layouts</a>, all featuring modern comforts like fully equipped kitchens and walk-in closets. Dive into the lifestyle you deserve today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Holly Court in Pitman, NJ, life's vibrant tapestry unfolds just beyond your doorstep. Enjoy proximity to cultural gems like the Broadway Theatre, the Pitman Historical Museum, and the artistry of the Pitman Gallery. With cozy studios to spacious two-bedroom apartments, your perfect home awaits—come and experience local treasures!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodshowcase.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Stylish Apartment Living in Pitman , NJ</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicycallout.description": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 11pt;\">We’re a pet-friendly community and happily welcome cats and dogs. Up to two pets are permitted per apartment. Breed restrictions apply. Please contact the leasing office for details.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Holly Court offers thoughtfully designed, <a href=\"https://www.livehollycourt.com/floor-plans/\">pet-friendly studio, one, and two bedroom apartments in Gloucester County</a> with the amenities and extras that make your life comfortable and worry-free. Enjoy an on-site dog park and swimming pool as well as an upgraded, contemporary kitchen and an in-home washer and dryer. Our charming community is conveniently located near popular dining, outdoor recreation, and shopping so your next-level living experience extends far beyond your front door.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Holly Court in charming Pitman, NJ, where comfort meets convenience. With thoughtfully designed studio, one-bedroom, and two-bedroom apartments, you’ll find the perfect home. Residents can easily access the portal to manage rent payments, request maintenance, and enjoy hassle-free living at its finest. Join us today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Holly Court in Pitman, NJ, choose from inviting studio, one-bedroom, and two-bedroom floor plans designed for modern living. Each space offers comfort and style, perfect for your lifestyle. Curious about our community? Schedule a tour today and hear directly from our residents about their home sweet home experience!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank you for reaching out to Holly Court in Pitman, NJ! With a variety of floor plans, including cozy studios and spacious two-bedrooms, we cater to your lifestyle needs. A team member will be in touch soon to guide you toward finding your perfect home at Holly Court.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Holly Court in Pitman, NJ, where modern living meets comfort. Choose from our thoughtfully designed studio, one-bedroom, or two-bedroom floor plans. Experience the inviting ambiance and vibrant community spirit—take a virtual tour to envision your new home today!</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contact-hero.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "View Floor Plans"
      }
    }
  },
  "pinnedcallouts.cta2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "propertyoverview.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "View Availability & Pricing"
      }
    }
  },
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/apply-now"
      }
    }
  },
  "amenitieslist.in_home_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfc-ae5d-7099-9cb9-dcd5f6995754.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bedroom with gray bedding, dark dresser, and window with blinds at Holly Court, offers apartments for rent in Pitman, NJ."
      }
    }
  },
  "amenitieslist.indoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfc-d220-77bb-9bdb-4adcf83d624c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bright community fitness center featuring treadmills, weight machines, and a mirrored wall at Holly Court, offers apartments near downtown Pitman, NJ."
      }
    }
  },
  "amenitieslist.indoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfc-d220-77bb-9bdb-4adcf83d624c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bright community fitness center featuring treadmills, weight machines, and a mirrored wall at Holly Court, offers apartments near downtown Pitman, NJ."
      }
    }
  },
  "amenitieslist.indoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166928/019d0270-1dc0-76cd-95f0-b41e1f6a4e23.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resident fitness center with treadmills, an elliptical, and a weight rack with mirrors at Holly Court in Pitman, NJ."
      }
    }
  },
  "amenitieslist.indoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166928/019d026f-c0d7-766a-bfd7-a3c4e722381e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Shared resident office and co-working lounge with a desk, chairs, sofa, and coffee table at Holly Court in Pitman, NJ."
      }
    }
  },
  "amenitieslist.inHomePhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfc-aeb4-7580-8bd5-93566eb0f3ab.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room in an apartment with sofa, armchair, coffee table, TV, plant, and dining area at Holly Court, offers apartments for rent in Pitman, NJ."
      }
    }
  },
  "amenitieslist.inHomePhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166928/019fcdfc-aebf-778a-8045-aa5d4f4a3cfc.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen with stainless steel appliances, dark wood cabinets, and granite countertops."
      }
    }
  },
  "amenitieslist.inHomePhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166928/019d026f-166d-737c-aa84-61d49c17503f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Cozy bedroom with a large bed, white closets, and a window with blinds."
      }
    }
  },
  "amenitieslist.neighborhood_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfc-d927-771f-b24f-d5b55c09533a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Two-story brick apartment building exterior with doors, balconies, and a green lawn at Holly Court, offers apartments in Pitman, NJ."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-4707-737a-b903-2ce1d7d03d56.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Alcyon Lake Park, a family-friendly lakeside park with trails a short walk from Holly Court in Pitman, NJ."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-24a4-7109-b4f9-2934b70ae48c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Broadway Theatre of Pitman, a restored 1920s venue in downtown Pitman near Holly Court, NJ."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-3319-7677-bd2b-5e65bf9d02af.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "The BB-62 Battleship New Jersey museum ship, a regional attraction near Holly Court in Pitman, NJ."
      }
    }
  },
  "amenitieslist.outdoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfc-ca4c-740b-90d9-151c94f336b0.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor apartment pool area with lounge chairs, tables under red umbrellas, and trees at Holly Court, offers apartments near downtown Pitman, NJ."
      }
    }
  },
  "amenitieslist.outdoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfc-cbd4-71de-a825-89d1465501b9.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor pool with lounge chairs and red umbrellas, surrounded by trees at Holly Court, offers apartments near downtown Pitman, NJ."
      }
    }
  },
  "amenitieslist.outdoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfc-d81e-762b-a646-69eca7ad9cef.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Covered wooden pavilion with metal picnic tables and a built-in grill at Holly Court, offers apartments in Pitman, NJ."
      }
    }
  },
  "amenitieslist.outdoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166928/019d0270-06aa-730e-a3db-bd1bde42dcc6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A fenced-in dog park with agility equipment and a dog house."
      }
    }
  },
  "feesheet.admin": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Admin Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$100"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.amenity": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Amenity Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$250"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.application": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Application Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.buyout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Buy-Out Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "1 Month's Rent"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.certificate": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Certificate of Occupancy"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$75"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.custom_optional": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Yearly Pool Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Annual"
      }
    }
  },
  "feesheet.electric": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Electric"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.gas": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Gas"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.late": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Late Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "10%"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.lockout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Lockout Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.month_to_month": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Month To Month"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$350"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.nsf": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "NSF Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.pet_fee": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$350"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Covers up to 2 pets."
      }
    }
  },
  "feesheet.pet_rent": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Rent"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      },
      "additional": {
        "type": "VALUE",
        "customValue": ""
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": ""
      }
    }
  },
  "feesheet.pet_rent_2nd": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amount": {
        "type": "VALUE",
        "customValue": "25"
      }
    }
  },
  "feesheet.reservation": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Reservation Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$200"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.security": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Security Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$1000*"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Deposit amount applies with approved credit and may be higher for conditional approvals"
      }
    }
  },
  "feesheet.transfer": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Transfer Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$500"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.trash": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Trash Service"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$10"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.utility_admin": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility Admin / Billing"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$4.66"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.utility_setup": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility New Account"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$10"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.water": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Water & Sewer"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "floorplanslist.card_image_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fce71-b0ff-770b-9cf3-8b7ed4c87d54.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen with dark cabinets, stainless steel appliances, and a granite countertop."
      }
    }
  },
  "floorplanslist.card_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fce71-b100-77fc-bc1d-fac10c39316a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom interior with bed, recliner, and stacked washer/dryer."
      }
    }
  },
  "floorplanslist.card_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fce71-b17e-742a-acad-bdff7ce55791.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with gray walls, sofa, TV, wooden furniture, and patterned rug."
      }
    }
  },
  "floorplanslist.card_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fce71-b1e5-760c-942c-2f17a67e5573.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dining area with a glass table, three chairs, and a gallery wall. A fan hangs from the ceiling. Kitchen in background."
      }
    }
  },
  "floorplanslist.card_image_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166928/019d026f-fc95-726b-865e-e3c031dbe91b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a king size bed, armchair, floor lamp, and stacked washer/dryer."
      }
    }
  },
  "neighborhoodhighlights.day_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfc-f343-72f7-adea-44f90f17d588.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Endgrain Coffee Roasters"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Coffee & Cafe"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "0.9 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Neighborhood favorite for local coffee and espresso that roasts its own beans."
      }
    }
  },
  "neighborhoodhighlights.day_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-1698-7369-9503-b6f26fb0e0d6.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Maggie Paige Boutique"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Shopping"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "0.7 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Charming downtown Pitman boutique stocking on-trend women's apparel, accessories and gifts."
      }
    }
  },
  "neighborhoodhighlights.day_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-4707-737a-b903-2ce1d7d03d56.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Alcyon Lake"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Parks & Recreation"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "1.1 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Picnic, soccer-, baseball- and softball-friendly, family-oriented park, offering a disc golf course, soccer fields, a playground, clean restrooms, a lakeside boat launch, and an extensive network of trails."
      }
    }
  },
  "neighborhoodhighlights.day_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfc-f427-726e-a666-c1fe989e79d0.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "George's Family Restaurant"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Breakfast & Brunch"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "0.2 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Longtime local favorite serving hearty breakfast, brunch and diner classics in a friendly, casual setting."
      }
    }
  },
  "neighborhoodhighlights.day_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-24be-7067-ab9b-bf43f1e1d6e4.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Pitman Gallery & Art Center"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Arts & Culture"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "0.8 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Community art center in downtown Pitman showcasing local artists with rotating exhibits, classes and workshops."
      }
    }
  },
  "neighborhoodhighlights.day_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-47ab-70e3-b00c-938db337f5d1.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Shertel Park NJ"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Recreation"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "1.0 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Relaxed park with a playground, plus basketball and tennis courts for casual play."
      }
    }
  },
  "neighborhoodhighlights.night_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-0a67-7150-baa0-4876dfc20aad.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Neck of the Woods Brewing"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Brewery & Taproom"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "0.9 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Local craft brewery and taproom pouring house-made beers in a laid-back, welcoming space."
      }
    }
  },
  "neighborhoodhighlights.night_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-24a4-7109-b4f9-2934b70ae48c.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Broadway Theatre of Pitman"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Live Entertainment"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "0.8 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Renovated 1920s-era venue hosting musical productions, children's theater & concerts."
      }
    }
  },
  "neighborhoodhighlights.night_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfc-fb5e-77f6-bcf8-0943524ff3c4.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Sweet Lula's American Restaurant"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Fine Dining"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "0.8 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Easygoing BYOB restaurant serving New American cooking with a global twist amid warm surrounds."
      }
    }
  },
  "neighborhoodhighlights.night_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-030e-77cf-8f0f-237953b5ae49.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Martini’s on Broadway"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Cocktail Lounge"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "0.8 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Relaxed, bar-focused eatery featuring specialty cocktails, including martini variations, plus steaks, burgers and flatbreads."
      }
    }
  },
  "neighborhoodhighlights.night_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfd-2c6f-77a9-9be5-7836d378487d.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "AMC Deptford 8"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Movie Theater"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "6.5 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Recliners in the clean theaters at this multiplex showing the latest flicks on large screens."
      }
    }
  },
  "neighborhoodhighlights.night_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166928/019fcdfc-fabd-708f-8ba3-49fc56c96479.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Alaura Homemade Ice Cream"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Dessert & Sweets"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "0.8 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Lively spot for homemade ice cream in a variety of creative flavors, plus a menu of grilled cheeses and hot dogs."
      }
    }
  },
  "neighborhoodshowcase.photo1": {
    "sourceIndex": 9,
    "fieldOverrides": null
  },
  "neighborhoodshowcase.photo2": {
    "sourceIndex": 16,
    "fieldOverrides": null
  },
  "neighborhoodshowcase.photo3": {
    "sourceIndex": 15,
    "fieldOverrides": null
  },
  "neighborhoodshowcase.photo4": {
    "sourceIndex": 14,
    "fieldOverrides": null
  },
  "pinnedcallouts.bg_image": {
    "sourceIndex": 11,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "propertyoverview.images": {
    "limit": 3,
    "hiddenIds": null,
    "orderedIds": [
      "custom_e7c022e4-8d0e-4c17-9b4a-9327e1eae5c2",
      "custom_37666aea-a6d2-414c-b93a-9bfd579a08e5",
      "custom_da68f7db-7fda-45f9-86b1-3fa5b2512b5c",
      "custom_2d8bd84b-1e1a-4894-939f-4f83998cd3be",
      "custom_dbc3ae9c-5cc4-4b51-80ca-d536cfb0565e",
      "custom_08934ebd-e2ae-404a-8858-7bd38a420558",
      "custom_a5e0aa1e-c848-40ff-986e-5fa9dc59c1c1",
      "custom_55362f87-58c0-47cd-a8c0-348fe59c9376",
      "custom_704c48cd-2b61-41d0-a6b5-a26c5b427aad"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "perq-floor-plan",
      "blockId": "perq-floor-plan",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 9
    }
  ],
  "apply-now": [
    {
      "sectionId": "realpage-oll",
      "blockId": "realpage-oll",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "_template:hyperlocal::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/air-conditioned-apartments-newport-news-city-harborstone-444::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/dog-park-apartments-newport-news-va-harborstone-222::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/extra-storage-apartments-fullerton-pa-469::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/fitness-center-apartments-23601-harborstone-366::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/pet-friendly-apartments-south-newport-news-harborstone-651::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "_section.InteractiveMapSection": {
    "properties": {
      "paddingTop": "50px",
      "paddingBottom": "50px",
      "backgroundColor": "#ffffff"
    }
  },
  "apartmentsyncsection.block": {
    "properties": {
      "paddingTop": "50px",
      "paddingBottom": "50px"
    }
  }
};
